module.exports = __webpack_public_path__ + "img/hero-img.660d6b1c.svg";